<div class="slider-center" [class.book-page]="bookPage">
  <div class="slider-wrapper" [class.show-dots]="showDots && !fullHeight">
    <div #sliderRef [id]="'ksl' + randomId" class="keen-slider" [class.full-height]="fullHeight"
      [style.justifyContent]="screenSizeService.isBrowser ? 'inherit' : 'center'">
      @for (slide of slides; track slide; let index = $index) {
      <app-slide [class.full-width]="slidesPerView === 1" [slide]="slide" [defaultNavbarColor]="defaultNavbarColor"
        [index]="randomId + index"></app-slide>
      }
    </div>

    @if (showDots) {
    <div class="dots" [fadeOnScroll]="hasTransparentNavbar()">
      @for (slide of dotHelper; track slide; let i = $index) {
      <button (click)="slider?.moveToIdx(i)" class="dot" [class.active]="i === currentSlide"></button>
      }
    </div>
    }

    <!-- prev/next arrows -->
    @if (slider && slides.length > 1 && showArrows) {
    <div class="arrows-main">
      <div class="arrows-container max-width">
        <div class="arrow arrow--left" [class.arrow--disabled]="currentSlide === 0" (click)="slider.prev()"></div>
        <div class="arrow arrow--right" [class.arrow--disabled]="isLastSlide()" (click)="slider.next()"></div>
      </div>
    </div>
    }
  </div>
</div>